var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSm5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon front"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3V21H4.5V3H19.5ZM19.5 1.5H4.5C4.10218 1.5 3.72064 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V21C3 21.3978 3.15804 21.7794 3.43934 22.0607C3.72064 22.342 4.10218 22.5 4.5 22.5H19.5C19.8978 22.5 20.2794 22.342 20.5607 22.0607C20.842 21.7794 21 21.3978 21 21V3C21 2.60218 20.842 2.22064 20.5607 1.93934C20.2794 1.65804 19.8978 1.5 19.5 1.5Z",
    fill: "#ffffff "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 17.25H6.75V18.75H8.25V17.25Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 17.25H15.75V18.75H17.25V17.25Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 13.5H6.75V15H8.25V13.5Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 13.5H15.75V15H17.25V13.5Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.75H6.75V11.25H8.25V9.75Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 17.25H11.25V18.75H12.75V17.25Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 13.5H11.25V15H12.75V13.5Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9.75H11.25V11.25H12.75V9.75Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9.75H15.75V11.25H17.25V9.75Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 5.25H6.75V7.5H17.25V5.25Z",
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm5);
export default __webpack_public_path__ + "static/media/sm5.00696afa0e453a1dfc57d410bf90d2e4.svg";
export { ForwardRef as ReactComponent };